var _style, _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 390.9 172.8",
    style: {
      enableBackground: "new 0 0 390.9 172.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF2600;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M346.7,160H44.1c-16.4,0-29.7-13.3-29.7-29.7V42.5c0-16.4,13.3-29.7,29.7-29.7h302.6 c16.4,0,29.7,13.3,29.7,29.7v87.8C376.4,146.7,363.1,160,346.7,160z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M165.8,64.2c0,7-5.1,12.6-12,12.6s-12.6-5.7-12.6-12.6s5.7-12.6,12.6-12.6c5,0,8.8,2.8,10.9,6.9l-2.4,0.7 c-1.6-3.1-4.7-5.2-8.5-5.2c-5.7,0-10.3,4.6-10.3,10.3s4.6,10.3,10.3,10.3c5.1,0,8.8-3.7,9.5-8.5h-10.4v-2.4h12.9V64.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.4,59.7c0,4.6-3,8.1-8.2,8.1h-5.9v8.8h-2.4V51.9h7C182.4,51.9,185.4,55,185.4,59.7z M183,59.9 c0-4-2.9-5.6-6.1-5.6h-5.7v11.1h5.9C180.3,65.4,183,63.9,183,59.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.3,69.9c0,3.7-3.6,6.9-8.7,6.9c-5.6,0-8.4-3.4-8.9-4l1.2-2.1c1.5,2,4.1,3.7,7.8,3.7 c3.4,0,6.3-2.1,6.3-4.7c0-2.3-1.4-3.9-6.2-4.8c-6.6-1.2-8.2-3.5-8.2-6.8c0-3.6,3.2-6.6,8.2-6.6c1,0,4.6,0.1,7.3,2.9l-1.1,2 c-1.2-1.3-3.4-2.6-6.3-2.6c-3.2,0-5.8,1.4-5.8,4.1c0,2.6,1.9,3.7,6.1,4.6C203,63.8,205.3,65.8,205.3,69.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.8,85.7h8.9l5.7,16l5.7-16h8.9l-10.9,26.8h-7.7L139.8,85.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.4,86c0-2.3,1.8-4.2,4.1-4.2c2.3,0,4.1,1.9,4.1,4.2c0,2.3-1.9,4.1-4.1,4.1 C171.3,90.2,169.4,88.3,169.4,86z M169.7,92.1h7.7v20.4h-7.7V92.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202.3,92.1v18.5c0,8.4-4.4,12.8-12.1,12.8c-5.4,0-10.2-3.2-10.2-3.2l2.6-5.7c0,0,2.9,2.1,7.1,2.1 c2.8,0,5.1-1.2,5.1-5.3v-0.8c-1.4,1.7-3.3,2.7-5.7,2.7c-5.3,0-9.6-4.9-9.6-10.8s4.3-10.8,9.6-10.8c2.4,0,4.4,1,5.7,2.7v-2.1 L202.3,92.1L202.3,92.1z M194.6,102.3c0-2.5-1.7-4.5-3.8-4.5s-3.8,2-3.8,4.5c0,2.5,1.7,4.5,3.8,4.5S194.6,104.8,194.6,102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.2,86c0-2.3,1.8-4.2,4.1-4.2c2.3,0,4.1,1.9,4.1,4.2c0,2.3-1.9,4.1-4.1,4.1 C207,90.2,205.2,88.3,205.2,86z M205.5,92.1h7.7v20.4h-7.7V92.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224,84.4v28.1h-7.7V84.4H224z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M248.9,92.1v20.4h-7.7v-2.1c-1.4,1.7-3.3,2.7-5.7,2.7c-5.3,0-9.6-4.9-9.6-10.8s4.3-10.8,9.6-10.8 c2.4,0,4.4,1,5.7,2.7v-2.1L248.9,92.1L248.9,92.1z M241.2,102.3c0-2.5-1.7-4.5-3.8-4.5s-3.8,2-3.8,4.5c0,2.5,1.7,4.5,3.8,4.5 S241.2,104.8,241.2,102.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.8,109.6c0-2.2,1.8-3.9,3.9-3.9c2.2,0,3.9,1.8,3.9,3.9s-1.8,3.9-3.9,3.9 C255.5,113.5,253.8,111.8,253.8,109.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M297.8,100.5v12.4H290v-11.1c0-2.4-0.9-3.3-2.3-3.3c-1.4,0-2.9,0.9-2.9,3.3v11.1h-7.8v-11.1 c0-2.4-0.9-3.3-2.3-3.3c-1.4,0-2.9,0.9-2.9,3.3v11.1h-7.8V92h7.8v2.6c1.2-2.2,3.5-3.3,5.9-3.3c2.4,0,4.5,1.1,5.8,3.2 c2.2-2.8,5.3-3.2,7.3-3.2C294.8,91.3,297.8,94.3,297.8,100.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.2,104.4h-13.3c0.3,1.7,2.3,2.6,4.7,2.6c3.4,0,5.4-1.3,5.4-1.3l2,5.9c0,0-2.9,2-8.1,2 c-8.4,0-12.1-5-12.1-11.1c0-6.1,3.6-11.1,11.1-11.1c6.7,0,10.5,4.1,10.5,11.1C320.3,103.1,320.3,103.7,320.2,104.4z  M312.3,100.5c0-1.7-0.9-3.3-2.8-3.3c-1.6,0-2.7,1.6-2.7,3.3H312.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.2,49.4c-16.4,0-29.7,13.3-29.7,29.7s13.3,29.7,29.7,29.7s29.7-13.3,29.7-29.7S116.6,49.4,100.2,49.4z  M100.2,53.9c14,0,25.3,11.3,25.3,25.2s-11.3,25.2-25.2,25.2S75,93.1,75,79.1S86.3,53.9,100.2,53.9z M108.2,65.7 c-0.5,0-1,0.1-1.4,0.3l0,0l-19.5,7.4l0,0c-2,0.8-3.3,2.7-3.3,4.8l0,0c0,2.1,1.3,4,3.3,4.7c0,0,0,0,0,0l6.7,2.4l2.4,6.7l0,0 c0.3,0.7,0.7,1.3,1.2,1.8l0,0c0.9,0.9,2.2,1.5,3.6,1.5h0c2.1,0,4-1.3,4.8-3.3l7.4-19.5l0,0c0.7-1.9,0.2-4-1.2-5.4l0,0 c-0.7-0.7-1.6-1.2-2.5-1.4C109.1,65.7,108.6,65.7,108.2,65.7z M108.7,70.2c0.1,0,0.2,0.1,0.3,0.2c0.2,0.2,0.2,0.4,0.1,0.7 l-7.4,19.5l0,0c-0.1,0.2-0.3,0.4-0.6,0.4c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.1-0.1-0.2-0.2v0l-2.8-7.6c-0.2-0.6-0.7-1.1-1.3-1.3 l-7.6-2.8h0c-0.3-0.1-0.4-0.3-0.4-0.6l0,0c0-0.3,0.2-0.5,0.4-0.6l19.5-7.4C108.4,70.2,108.5,70.2,108.7,70.2z"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMe);
export default __webpack_public_path__ + "static/media/me.be7bba0f74c73bcded5c819af868328b.svg";
export { ForwardRef as ReactComponent };